<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-0 text-center" v-text="'Anulowanie subskrypcji'" />
        </template>

        <h5 v-text="'Wybierz sklepy, w których chcesz anulować subskrypcję'" />

        <mass-selection-buttons
            class="mt-3 mb-2"
            :value="isAllLocationsSelected"
            @select="toggleAllLocations"
        />

        <div
            v-for="shop in cancelableShops"
            :key="shop.id"
            class="drs-shop"
            :class="{ selected: selectedShops.includes(shop.id) }"
        >
            <ui-checkbox-input
                class="text-sm"
                :name="`shop-${shop.id}`"
                :label="`${shop.full_name}, ${shop.fullAddress}`"
                :value="selectedShops.includes(shop.id)"
                @change="toggleShopSelection(shop.id)"
            />
        </div>

        <template #footer>
            <the-btn text="Zamknij" class="btn-outline-custom" @click="$emit('close-modal')" />
            <the-btn
                :disabled="selectedShops.length === 0"
                text="Anuluj subskrypcję"
                class="btn-danger"
                @click="confirmCancellation"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
        isAllLocationsSelected: false,
        selectedShops: []
    }),

    methods: {
        confirmCancellation() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/payment/CancelConfirm',
                args: {
                    selectedShops: this.selectedShops
                }
            })
        },

        toggleAllLocations(value) {
            this.isAllLocationsSelected = value
            this.selectedShops = this.isAllLocationsSelected
                ? this.cancelableShops.map(shop => shop.id)
                : []
        },

        toggleShopSelection(shopId) {
            if (this.selectedShops.includes(shopId)) {
                this.selectedShops = this.selectedShops.filter(id => id !== shopId)
            } else {
                this.selectedShops.push(shopId)
            }
        }
    },

    computed: {
        ...mapGetters('drs', ['cancelableShops'])
    },

    created() {
        this.selectedShops = this.cancelableShops.map(shop => shop.id)
    }
}
</script>

<style lang="scss" scoped>
.drs-shop {
    --padding: 1.25rem;
    padding: var(--padding);
    border-radius: 4px;
    border: 1px solid var(--color-gray-300);
    color: var(--color-primary);

    + .drs-shop {
        margin-top: .5rem;
    }

    &.selected {
        background-color: var(--active-promo-bg);
        border: 2px solid var(--color-primary);
        padding: calc(var(--padding) - 1px);
        font-weight: 500;

        &:hover {
            border-width: 2px;
        }
    }
}
</style>